export function renameFile(file: File, rename: string): File {
  return new File([file], rename, {type: file.type});
}

export function downloadFile(file: File) {
  const dataURI = URL.createObjectURL(file);
  const fileLink = document.createElement("a");
  fileLink.href = dataURI;
  fileLink.download = file.name;
  fileLink.click();
  fileLink.remove();
  URL.revokeObjectURL(dataURI);
}


export function downloadTextAsFile(fileName: string, content: string) {
  downloadFile(new File([content], fileName, {type: "text/plain"}))
}

export function downloadFileBasedOnLink(link: string) {
  const fileLink = document.createElement("a");
  fileLink.href = link;
  fileLink.click();
  fileLink.remove();
}

export class ErrorInUploadedFile extends Error {
  constructor(msg: string) {
    super(msg);
    Object.setPrototypeOf(this, ErrorInUploadedFile.prototype);
  }
}

export class FileNotUploadedError extends Error {
  constructor(msg: string) {
    super(msg);
    Object.setPrototypeOf(this, FileNotUploadedError.prototype);
  }
}
